export enum TreeItemTypes {
  ROW = "row",
  COLUMN = "column",
  BOX = "box",
  IMAGE = "image",
  TEXT = "text",
  TABLE = "table",
  LIST = "list",
  FLOAT = "float",
  DUMMY = "dummy",
}
